import { render, staticRenderFns } from "./finalVersionCaseList.vue?vue&type=template&id=2ebd638c&scoped=true"
import script from "./finalVersionCaseList.vue?vue&type=script&lang=js"
export * from "./finalVersionCaseList.vue?vue&type=script&lang=js"
import style0 from "./finalVersionCaseList.vue?vue&type=style&index=0&id=2ebd638c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ebd638c",
  null
  
)

export default component.exports